import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=1b92f8d9&scoped=true"
import script from "./checkbox-group.vue?vue&type=script&lang=ts"
export * from "./checkbox-group.vue?vue&type=script&lang=ts"
import style0 from "./checkbox-group.vue?vue&type=style&index=0&id=1b92f8d9&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b92f8d9",
  null
  
)

export default component.exports